import { render, staticRenderFns } from "./LaminarTurbulentViz.vue?vue&type=template&id=65888dda&scoped=true"
import script from "./LaminarTurbulentViz.vue?vue&type=script&lang=js"
export * from "./LaminarTurbulentViz.vue?vue&type=script&lang=js"
import style0 from "./LaminarTurbulentViz.vue?vue&type=style&index=0&id=65888dda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65888dda",
  null
  
)

export default component.exports